import React from 'react';

function TrueFalseQuestion({ question, value = '', onChange, disabled = false }) {
  return (
    <div>
      {question.statement && (
        <div className="mb-5 p-4 bg-gray-50 border-l-4 border-blue-400 rounded-r shadow-sm">
          <p className="italic text-gray-700">{question.statement}</p>
        </div>
      )}
      
      <div className="space-y-3 mt-4">
        {question.options.map((option, index) => (
          <label 
            key={index} 
            className={`flex items-center p-3 rounded-lg transition-all duration-200 ${
              value === option 
                ? 'bg-blue-50 border border-blue-200 shadow-sm' 
                : 'hover:bg-gray-50 border border-transparent'
            } ${disabled ? 'opacity-70 cursor-not-allowed' : 'cursor-pointer'}`}
          >
            <input
              type="radio"
              name={`question-${question.id}`}
              value={option}
              checked={value === option}
              onChange={(e) => onChange(e.target.value)}
              className="form-radio h-5 w-5 text-blue-600 focus:ring-blue-500"
              disabled={disabled}
            />
            <span className={`ml-3 text-gray-800 ${value === option ? 'font-medium' : ''}`}>
              {option}
            </span>
          </label>
        ))}
      </div>
    </div>
  );
}

export default TrueFalseQuestion;
